import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import { PaginatedData } from '../../../../../models/List';
import {
  PaymentReportExportResponse,
  PaymentReportSearchRequest,
  PaymentReportSearchResponse,
} from '../../model';
import { DropDownItem } from '../../../../../hooks/dropdown';

const userBaseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/user/api`;
const candidateBaseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const reportingBaseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/reporting/api`;
const timeout = 30000;

export const userClient = axiosFactory(userBaseURL, 5000);

export const opsAdminCandidateClient = axiosFactory(candidateBaseURL, timeout);

export const opsAdminReportingClient = axiosFactory(reportingBaseURL, timeout);

/** Search the payment report */
export const postPaymentReportSearch = (csrfToken: string, data: PaymentReportSearchRequest) =>
  opsAdminReportingClient.post<PaginatedData<PaymentReportSearchResponse>>(
    csrfToken,
    ROUTES.POST_PAYMENT_REPORT_SEARCH({
      order: data.order,
      sort: data.sort,
      page: data.page,
      pageSize: data.pageSize,
    }),
    {
      transactionType: data.transactionType,
      organisationUuid: data.organisationUuid,
      examLevelCode: data.examLevelCode,
      paymentMethodCode: data.paymentMethodCode,
      q: data.q,
      startDate: data.startDate,
      endDate: data.endDate,
      paymentStatus: data.paymentStatus,
    }
  );

/** Export the Payment Report */
export const postPaymentReportExportExcel = (csrfToken: string, data: PaymentReportSearchRequest) =>
  opsAdminReportingClient.post<PaymentReportExportResponse>(
    csrfToken,
    ROUTES.POST_PAYMENT_REPORT_EXPORT_EXCEL,
    {
      transactionType: data.transactionType,
      organisationUuid: data.organisationUuid,
      examLevelCode: data.examLevelCode,
      paymentMethodCode: data.paymentMethodCode,
      q: data.q,
      startDate: data.startDate,
      endDate: data.endDate,
      paymentStatus: data.paymentStatus,
    }
  );

export const getOrganisations = () =>
  userClient.get<DropDownItem[]>(ROUTES.GET_REPORTING_ORGANISATIONS);

export const getTransactionTypes = () =>
  opsAdminReportingClient.get<DropDownItem[]>(ROUTES.GET_TRANSACTION_TYPES);

export const getReportsExamLevels = (functionName: string) =>
  opsAdminReportingClient.get<DropDownItem[]>(ROUTES.GET_EXAM_LEVELS(functionName));

export const getCheckEligibility = () =>
  opsAdminReportingClient.get<void>(ROUTES.GET_CHECK_ELIGIBILITY);

export const getPaymentStatuses = () =>
  opsAdminReportingClient.get<DropDownItem[]>(ROUTES.GET_PAYMENT_STATUSES);
